import React from 'react'
import NewWindow from "react-new-window";

const NewWinPDF = ({children}) => {
  return (
    <NewWindow
        title="미리보기"
        features={{
        outerHeight: "100%",
        outerWidth: "100%"
        }}
    >
      {children}
    </NewWindow>
  )
}

export default NewWinPDF
